import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Edit from '@material-ui/icons/Edit';
import Loading from '../loading/loading';
import FloatingActionButton from "../elements/floatingActionButton";
import {TABLE_VIEW_AMOUNTS} from "../../helpers/constants";
import FilterListIcon from "@material-ui/icons/FilterList";
import CustomModal from "../elements/customModal";
import PersonsFilterForm from "../personsList/personsFilterForm";
import ClearAll from '@material-ui/icons/ClearAll';
import Button from "@material-ui/core/Button/Button";
import TableSortLabel from '@material-ui/core/TableSortLabel';
import _ from 'lodash';
import PersonsListMobileView from './personsListMobileView';
import MediaQuery from "react-responsive";
import {scrollToElement} from "../../helpers/functions";
import Snackbar from "@material-ui/core/Snackbar";
import PersonDeleteModal from "./personDeleteModal";

const columnData = [
  { id: 'username', numeric: false, disablePadding: false, label: 'Username' },
  { id: 'email', numeric: false, disablePadding: false, label: 'Email' },
  { id: 'role', numeric: false, disablePadding: false, label: 'Role' },
  { id: 'department', numeric: false, disablePadding: false, label: 'Department' },
];

class EnhancedTableHead extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount, order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell />
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  '@media screen and (max-width: 768px)': {
    root: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Persons
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : <div>
          <Button color="secondary" className={classes.button} onClick={props.clearFilters}>
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button color="primary" className={classes.button} onClick={props.openFilterModal}>
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
        </div>}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  '@media screen and (max-width: 768px)': {
    pager: {
      paddingBottom: '8% !important',
    },
    pagerToolbar: {
      flexWrap: 'wrap !important',
      justifyContent: 'center !important'
    }
  }
});

class PersonsList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      order: 'asc',
      orderBy: 'email',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 100,
      filterModalOpen: false,
      deleteModalOpen: false,
      person: null
    };

    this.personsListRef = React.createRef();

  }

  _openDeleteModal = (person) => {
    this.setState({
      ...this.state,
      deleteModalOpen: true,
      person: person
    })
  };

  _closeDeleteModal = () => {
    this.setState({
      ...this.state,
      deleteModalOpen: false,
      person: null
    })
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.props.persons.map(n => n.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  openFilterModal = () => {
    this.setState({ filterModalOpen: true });
  };

  closeFilterModal = () => {
    this.setState({ filterModalOpen: false });
  };

  filterPersons = (formIM) => {
    const whereAndFilter = [
      {departmentId: formIM.get('departmentId')},
    ];
    if(formIM.get('username')){
      whereAndFilter.push({username : {like: `%25${formIM.get('username')}%25`}})
    }
    if(formIM.get('email')){
      whereAndFilter.push({email : {like: `%25${formIM.get('email')}%25`}})
    }
    this.props.getPersons({
      filter: {
        where: {and: whereAndFilter},
        include: ['roles', 'department']
      }
    });
    this.closeFilterModal();
  };

  clearFilters = () => {
    this.props.getPersons({
      filter: {
        include: ['roles', 'department']
      }
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  _changeLocalState = (payload) => {
    this.setState({
      ...this.state,
      [payload.key]: payload.value
    })
  };

  render() {
    const { classes } = this.props;
    const { selected, rowsPerPage, page, order, orderBy } = this.state;
    const data = this.props.persons;

    return (
      <div>
        <CustomModal
          customStyle={{width: '60%'}}
          open={this.state.deleteModalOpen}
          handleClose={this._closeDeleteModal}
          content={
            <PersonDeleteModal
              {...this.props}
              classes={null}
              person={this.state.person}
              _closeDeleteModal={this._closeDeleteModal}
            />
          }
        />
        <CustomModal
          open={this.state.filterModalOpen}
          handleClose={this.closeFilterModal}
          content={<PersonsFilterForm {...this.props} filterPersons={this.filterPersons} handleCancel={this.closeFilterModal}/>}
        />
        <Loading displayLoader={this.props.loading}/>
        <MediaQuery query="(max-device-width: 768px)">
          <PersonsListMobileView
            {...this.props}
            classes={null}
            clearFilters={this.clearFilters}
            openFilterModal={this.openFilterModal}
            filterPersons={this.filterPersons}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            page={page}
            _changeLocalState={this._changeLocalState}
            rowsPerPage={rowsPerPage}
            _openDeleteModal={this._openDeleteModal}
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 769px)">
          <div ref={this.personsListRef}>
            <Paper className={classes.root}>
              <EnhancedTableToolbar
                {...this.props}
                numSelected={selected.length}
                classes={null}
                openFilterModal={this.openFilterModal}
                clearFilters={this.clearFilters}
              />
              <div className={classes.tableWrapper}>
                <Table className={classes.table + ' table-sm compact'} aria-labelledby="tableTitle">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={this.handleSelectAllClick}
                    rowCount={data.length}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {_.orderBy(data, item => {
                      if(orderBy === 'username') {return item.username}
                      if(orderBy === 'email') {return item.email}
                      if(orderBy === 'department') {return item.department?item.department.name:''}
                      if(orderBy === 'role') {return  item.roles[0]? item.roles[0].name : ''}
                    }, order)
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map(n => {
                        const isSelected = this.isSelected(n.id);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isSelected}
                            tabIndex={-1}
                            key={n.id}
                            selected={isSelected}
                          >
                            <TableCell padding="checkbox">
                              <IconButton
                                aria-label="Edit user"
                                onClick={() => this.props.history.push('/person/' + n.id)}>
                                <Edit/>
                              </IconButton>
                              {this.props.loggedInPersonId !== n.id && (
                                <IconButton
                                  aria-label="Delete"
                                  onClick={() => this._openDeleteModal(n)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                              {n.username}
                            </TableCell>
                            <TableCell >
                              {n.email}
                            </TableCell>
                            <TableCell>
                              {
                                n.roles[0]?
                                  n.roles[0].name
                                  :
                                  ''
                              }
                            </TableCell>
                            <TableCell >
                              {n.department?n.department.name: ''}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                classes={
                  {
                    root: classes.pager,
                    toolbar: classes.pagerToolbar
                  }
                }
                rowsPerPageOptions={TABLE_VIEW_AMOUNTS}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={(evt, page) => {
                  scrollToElement(this.personsListRef.current);
                  this.handleChangePage(evt, page)
                }}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </MediaQuery>
        <FloatingActionButton onClick={() => this.props.history.push('/person')}/>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={!!this.props.deletePersonResponseMessage}
          onClose={() => { this.props.changePersonState({key: 'message', value: ''}) }}
          ContentProps={{'aria-describedby': 'message-id',}}
          message={<span id="message-id">{this.props.deletePersonResponseMessage}</span>}
        />
      </div>
    );
  }
}

PersonsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PersonsList);



// WEBPACK FOOTER //
// ./src/components/personsList/personsList.js